import { configureStore } from '@reduxjs/toolkit';

import sessionReducer from '_app/features/session/sessionSlice';

export const createAppStore = () =>
  configureStore({
    reducer: {
      session: sessionReducer,
    },
  });

export const store = createAppStore();
